import { createElement as rc } from 'react';
import BaseIcon from './BaseIcon.gl2025';

// Map old Material Icon names to new GL2025 icon names
export const iconNameMapping = {
    // Notification icons
    notifications: 'bell',
    'notifications-none': 'bell',
    'notifications-active': 'bell-notification',
    'notifications-off': 'bell-off',
    // Sync/refresh icons
    cached: 'refresh-cw',
    'published-with-changes': 'refresh-cw',
    sync: 'refresh-cw',
    refresh: 'refresh-cw',
    autorenew: 'refresh-cw',
    // User/profile icons
    person: 'user',
    'person-outline': 'user',
    'account-circle': 'user',
    'perm-identity': 'user',
    // Common action icons
    close: 'x',
    check: 'check',
    add: 'plus',
    remove: 'minus',
    delete: 'trash-2',
    edit: 'edit-2',
    search: 'search',
    'manage-search': 'search',
    settings: 'settings',
    menu: 'menu',
    'more-vert': 'more-vertical',
    'more-horiz': 'more-horizontal',
    // Arrow icons
    'arrow-back': 'arrow-left',
    'arrow-forward': 'arrow-right',
    'arrow-upward': 'arrow-up',
    'arrow-downward': 'arrow-down',
    'expand-more': 'chevron-down',
    'expand-less': 'chevron-up',
    'chevron-left': 'chevron-left',
    'chevron-right': 'chevron-right',
    // Info/status icons
    info: 'info',
    warning: 'alert-triangle',
    error: 'alert-circle',
    help: 'help-circle',
    'help-outline': 'help-circle',
    // Layer icons
    layers: '2-layers',
    '2-layers': '2-layers',
    '3-layers': '3-layers',
    // Touch/pointer icons
    'touch-app': 'switch-horizontal-01',
    touch: 'mouse-pointer',
    // Additional Material icons
    'date-range': 'calendar',
    'done-all': 'clipboard-check',
    description: 'file-text',
    'account-tree': 'dataflow',
    router: 'rfid-box',
    'cloud-upload': 'download',
    'cloud-download': 'upload',
    print: 'printer',
    'playlist-remove': 'file-minus',
    'view-week': 'sliders-01',
    'menu-open': 'menu',
    'fiber-manual-record': 'settings',
    security: 'shield',
    shield: 'shield-zap',
    'photo-camera': 'camera',
    'read-more': 'more-horizontal',
    'add-link': 'rfid-box',
    'keyboard-double-arrow-down': 'chevrons-down',
    clear: 'x',
    done_all: 'check-circle',
    block: 'slash'
};

function mapIconName(iconName) {
    if (!iconName) return iconName;
    const normalized = iconName.replace(/_/g, '-');
    return iconNameMapping[normalized] ?? normalized;
}

function BaseIconAdapter(props) {
    const {
        name,
        color, // icon color for new BaseIcon component
        fontColor, // icon color for old Icon component
        size = 'md',
        fill = false,
        children,
        ...otherProps
    } = props;

    const iconParts = children?.split('|') ?? [];
    const oldIconName = iconParts[0]?.replace(/_/g, '-');
    const resolvedName = mapIconName(name ?? oldIconName);

    return rc(BaseIcon, {
        name: resolvedName,
        color: color ?? fontColor ?? 'currentColor',
        size,
        fill,
        children,
        fontColor,
        ...otherProps
    });
}

export default BaseIconAdapter;
